import { getBeautyQueries } from './getBeautyQueries';
import { getAgeFilters } from './getAgeFilters';
import { getPopularKeywords } from './getPopularKeywords';
import { getSuggestKeywords } from './getSuggestKeywords';
import { getAssistantInfo } from './getAssistantInfo';
import { getRelatedKeywords } from './getRelatedKeywords';
import { getRecommendedGoods } from './getRecommendedGoods';
import { postNonEntryMarkets } from './postNonEntryMarkets';

export const searchService = {
  getBeautyQueries: getBeautyQueries,
  getAgeFilters: getAgeFilters,
  getPopularKeywords: getPopularKeywords,
  getSuggestKeywords: getSuggestKeywords,
  getAssistantInfo: getAssistantInfo,
  getRelatedKeywords: getRelatedKeywords,
  getRecommendedGoods: getRecommendedGoods,
  postNonEntryMarkets: postNonEntryMarkets,
};
